import { useState, useEffect } from "react";
import styled from "styled-components";

import { Stack, IconButton, Typography } from "@mui/material";
import Dialog from "src/components/core/Dialog";
import Button from "src/components/core/Button";

import CloseIcon from "@mui/icons-material/Close";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

import { DialogTitle, DialogContent, DialogActions } from "@mui/material";

import { useDialog } from "src/context/DialogContext";
import { useSnackbar } from "notistack";

import { arrayMove } from "@dnd-kit/sortable";
import DraggableBoard, {
  DraggableItem,
} from "src/components/core/DraggableBoard";

import font from "src/styles/font";
import { Grey, GreyStroke, White } from "src/styles/color";

import { getAllSections, moveSectionPosition } from "src/api/landingPage";

const S = {};

S.SectionListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 16px;
`;

S.SectionItemWrapper = styled(DraggableItem)`
  position: relative;
  width: 100%;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid ${GreyStroke};
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${White};
`;

S.SectionName = styled.span`
  font-size: ${font.size.md};
  font-weight: 500;
  user-select: none;
  white-space: nowrap;
`;

S.SectionItemAction = styled.div`
  display: flex;
  align-items: center;
`;

const SectionRearrangeDialog = ({ onClose, onSuccess }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { openDialog } = useDialog();

  const [sections, setSections] = useState([]);

  const handleSubmit = async () => {
    try {
      await moveSectionPosition({ section: sections });

      enqueueSnackbar(`แก้ไขสำเร็จ`, {
        variant: "success",
      });
      onSuccess();
    } catch (err) {
      console.error(err);
    }
  };

  // const moveUp = (index) => {
  //   const newIndex = index - 1;
  //   const newReArranged = arrayMove(sections, index, newIndex);
  //   setSections(newReArranged);
  // };

  // const moveDown = (index) => {
  //   const newIndex = index + 1;
  //   const newReArranged = arrayMove(sections, index, newIndex);
  //   setSections(newReArranged);
  // };

  const fetchSections = async () => {
    try {
      const result = await getAllSections();
      setSections(result.section);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSections();
  }, []);

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={true}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: 1024,
            maxWidth: "100%",
          },
        },
        "& .MuiDialogContent-root": {
          pt: 1,
          pb: 4,
        },
      }}
    >
      <DialogTitle sx={{ p: 3 }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack width="100%" alignItems="center">
          <Typography
            variant="body1"
            sx={{
              fontWeight: 500,
            }}
          >
            สลับตำแหน่ง
          </Typography>
          <DraggableBoard
            items={sections}
            onDragEnd={({ active, over }) => {
              if (active.id !== over?.id) {
                setSections((prev) => {
                  const oldIndex = prev.findIndex(
                    (item) => item._id === active.id,
                  );
                  const newIndex = prev.findIndex(
                    (item) => item._id === over.id,
                  );

                  const newReArranged = arrayMove(prev, oldIndex, newIndex);
                  // moveBannerPosition(newReArranged);

                  return newReArranged;
                });
              }
            }}
            Components={{
              DroppableParent: ({ items, children }) => {
                return (
                  <S.SectionListContainer>
                    {children({ items })}
                  </S.SectionListContainer>
                );
              },
              DraggableItem: (props) => {
                const { item, items, ...rest } = props; // Destructuring items to prevent this spreading to html element
                return (
                  <S.SectionItemWrapper {...rest}>
                    <S.SectionItemAction>
                      <DragIndicatorIcon
                        sx={{
                          color: Grey,
                          marginRight: 1,
                        }}
                      />
                      <S.SectionName>{item.name}</S.SectionName>
                    </S.SectionItemAction>
                    {/* <S.SectionItemAction>
                      <IconButton
                        onClick={() => {
                          moveUp(index);
                        }}
                        disabled={index === 0}
                      >
                        <KeyboardArrowUpIcon />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          moveDown(index);
                        }}
                        disabled={index === items?.length - 1}
                      >
                        <KeyboardArrowDownIcon />
                      </IconButton>
                    </S.SectionItemAction> */}
                  </S.SectionItemWrapper>
                );
              },
            }}
          />
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
        }}
      >
        <Button
          variant="outlined"
          size="large"
          onClick={onClose}
          sx={{
            minWidth: 160,
          }}
        >
          ยกเลิก
        </Button>
        <Button
          variant="contained"
          size="large"
          onClick={() => {
            openDialog({
              type: "confirm",
              title: `คุณต้องการบันทึกการแก้ไขใช่หรือไม่?`,
              onConfirm: async () => {
                await handleSubmit();
              },
              maxWidth: 342,
            });
          }}
          sx={{
            minWidth: 160,
          }}
          autoFocus // enable auto focus to increase accessibility
        >
          บันทึก
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SectionRearrangeDialog;
